// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';
import SectionBanner from "../../components/section-banner/index";
import TwoColumns from "../../components/two-columns/index";
import SectionPlainText from "../../components/section-plain-text/index";
import Video from "../../components/video/index";

export default {
    name: "homepage",
    components: {
        Video,
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent,
        SectionBanner,
        TwoColumns,
        SectionPlainText
    },
    data(){
        return {
            chartPreviousYear: [
                {
                    pid: '5351',
                    imgPath: '2022/5351.jpg',
                    selected: false,
                    ranking: '1°'
                },
                {
                    pid: '1029',
                    imgPath: '2022/1029.jpg',
                    selected: false,
                    ranking: '2°'
                },
                {
                    pid: "5129",
                    imgPath: '2022/5129.jpg',
                    selected: false,
                    ranking: '3°'
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}